export const base_url=process.env.NODE_ENV==='production' ? "" : 'http://localhost:3000/';


export const popupImages={
	close_icon:{
		url:`${base_url}images/popup-close.svg`
	}
}